"use client";

import {
  METADATA_LOCAL_STORAGE_KEY,
  metadataSchema,
  SCHEMA_VERSION,
  APP_VERSION,
  type Metadata,
  DEFAULT_MOBILE_TAB,
} from "@/app/schema";
import dayjs from "dayjs";

export const DEFAULT_METADATA = {
  appVersion: APP_VERSION,
  schemaVersion: SCHEMA_VERSION,
  invoiceCreatedAt: dayjs().toISOString(),
  invoiceLastUpdatedAt: dayjs().toISOString(),
  lastVisitedMobileTab: DEFAULT_MOBILE_TAB,
  invoiceDownloadCount: 0,
} as const satisfies Metadata;

export function getAppMetadata() {
  try {
    const metadata = localStorage.getItem(METADATA_LOCAL_STORAGE_KEY);
    if (!metadata) return null;
    const parsedMetadata = JSON.parse(metadata) as Metadata;
    const validatedMetadata = metadataSchema.safeParse(parsedMetadata);
    if (!validatedMetadata.success) {
      console.error(
        "[getAppMetadata] Error validating app metadata:",
        validatedMetadata.error,
      );
      return null;
    }
    return validatedMetadata?.data;
  } catch (error) {
    console.error("[getAppMetadata] Error parsing invoice metadata:", error);
    return null;
  }
}

export function updateAppMetadata(updater: (current: Metadata) => Metadata) {
  try {
    const existingMetadata = getAppMetadata();
    if (!existingMetadata) {
      return;
    }
    const nextMetadata = updater(existingMetadata);
    const parsed = metadataSchema.safeParse(nextMetadata);
    if (!parsed.success) {
      console.error("[updateAppMetadata] Validation error:", parsed.error);
      localStorage.setItem(
        METADATA_LOCAL_STORAGE_KEY,
        JSON.stringify(DEFAULT_METADATA),
      );
      return;
    }
    localStorage.setItem(
      METADATA_LOCAL_STORAGE_KEY,
      JSON.stringify(parsed.data),
    );
  } catch (error) {
    console.error("[updateAppMetadata] Failed to save metadata:", error);
  }
}
